import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=48ba4f9e"
import script from "./PurchaseDialog.vue?vue&type=script&lang=ts"
export * from "./PurchaseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports